import { gql } from "@apollo/client";

export const CREATE_INVOICE = gql`
  mutation CreateInvoices($data: InvoiceInput!) {
    createInvoices(data: $data) {
      id
    }
  }
`;

export const UPDATE_INVOICE_TO_REJECT = gql`
  mutation InvoicesReject($data: InvoiceInput!, $where: InvoiceWhereInputOne!) {
    invoicesReject(data: $data, where: $where) {
      id
    }
  }
`;
